<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Update Propulsion Scenario with External Data</h1>
  </div>
</div>
<div class="input-file-format-container">
  <h4 class="font-weight-bold default-margin">
    Process Action
  </h4>
  <mat-radio-group [(ngModel)]="isPreprocess">
    <mat-radio-button [value]="true">Preprocess to view action on records</mat-radio-button>
    <mat-radio-button [value]="false">Process to save records into scenario</mat-radio-button>
  </mat-radio-group>
</div>
<div>
  <mat-checkbox [(ngModel)]="isUpdateDates">
    Update Dates
  </mat-checkbox>
</div>
<div class="drag-and-drop-container">
  <h4>
    <span class="template-dropzone-label">Please Select File to select worksheets from. </span> (Required
    Format: .xls or .xlsx)
  </h4>
</div>
<div (files)="upload($event)" appDrag class="dropzone">
  <div class="text-wrapper">
    <div class="centered">Drag and Drop Files Here</div>
    <p class="centered">or</p>
    <div>
      <app-upload-button (eventEmitter)="upload($event)" [apiUrl]="excelService.excelSheetUrl"
                         class="upload centered app-upload-button">
      </app-upload-button>
    </div>
  </div>
</div>
